const TRUST_ITEMS = [
  {
    icon: "ri-shield-check-fill",
    value: "LIC #M12160",
    label: "Licensed & Insured",
    sub: "TX Master Plumber",
  },
  {
    icon: "ri-timer-flash-fill",
    value: "Same Day",
    label: "Fast Response",
    sub: "24/7 Emergency Available",
  },
  {
    icon: "ri-map-pin-2-fill",
    value: "35+ Years",
    label: "Locally Trusted",
    sub: "Serving DFW Since 1989",
  },
  {
    icon: "ri-medal-fill",
    value: "Master",
    label: "Expert Technicians",
    sub: "Master Plumber Owned",
  },
];

interface TrustBarProps {
  dark?: boolean;
}

export default function TrustBar({ dark = false }: TrustBarProps) {
  return (
    <div
      className={`w-full ${
        dark ? "bg-[#0B1829]" : "bg-white border-b border-gray-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {TRUST_ITEMS.map((item) => (
            <div key={item.label} className="flex items-center gap-4">
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${
                  dark ? "bg-[#E8500A]/15" : "bg-orange-50"
                }`}
              >
                <i className={`${item.icon} text-[#E8500A] text-xl`} />
              </div>
              <div>
                <p
                  className={`font-black text-base leading-none mb-0.5 ${
                    dark ? "text-white" : "text-gray-900"
                  }`}
                  style={{ fontFamily: "'Barlow', sans-serif" }}
                >
                  {item.value}
                </p>
                <p
                  className={`font-semibold text-xs ${
                    dark ? "text-white/80" : "text-gray-800"
                  }`}
                >
                  {item.label}
                </p>
                <p
                  className={`text-xs mt-0.5 ${
                    dark ? "text-white/40" : "text-gray-400"
                  }`}
                >
                  {item.sub}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
